<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Meu Perfil</h4>
            
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando perfil...</span>
              </div>
              <p class="mt-2">Carregando dados do perfil...</p>
            </div>

            <div v-else>
              <!-- Informações do Usuário (Somente Leitura) -->
              <div class="row">
                <div class="col-12">
                  <h5>Informações Pessoais</h5>
                  <hr>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    label="Nome Completo"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      :value="userProfile.name || 'Não informado'"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      :value="userProfile.email"
                      type="email"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    label="Tipo de Usuário"
                    label-for="role"
                  >
                    <b-form-input
                      id="role"
                      :value="getRoleLabel(userProfile.role)"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    label="CPF"
                    label-for="cpf"
                  >
                    <b-form-input
                      id="cpf"
                      :value="userProfile.cpf || 'Não informado'"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row" v-if="userProfile.role === 'DOCTOR'">
                <div class="col-md-6">
                  <b-form-group
                    label="CRM"
                    label-for="crm"
                  >
                    <b-form-input
                      id="crm"
                      :value="userProfile.crm || 'Não informado'"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    label="Especialidade"
                    label-for="especialidade"
                  >
                    <b-form-input
                      id="especialidade"
                      :value="userProfile.especialidade_nome || 'Não informado'"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row" v-if="userProfile.cbo">
                <div class="col-md-6">
                  <b-form-group
                    label="CBO"
                    label-for="cbo"
                  >
                    <b-form-input
                      id="cbo"
                      :value="userProfile.cbo"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    label="Status"
                    label-for="status"
                  >
                    <b-form-input
                      id="status"
                      :value="userProfile.is_active ? 'Ativo' : 'Inativo'"
                      type="text"
                      readonly
                      class="form-control-plaintext"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <!-- Seção de Alteração de Senha -->
              <div class="row mt-4">
                <div class="col-12">
                  <h5>Alterar Senha</h5>
                  <hr>
                </div>
              </div>

              <form @submit.prevent="changePassword">
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      label="Senha Atual *"
                      label-for="current_password"
                      :invalid-feedback="errors.current_password"
                      :state="errors.current_password ? false : null"
                    >
                      <b-form-input
                        id="current_password"
                        v-model="passwordForm.current_password"
                        type="password"
                        required
                        placeholder="Digite sua senha atual"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      label="Nova Senha *"
                      label-for="new_password"
                      :invalid-feedback="errors.new_password"
                      :state="errors.new_password ? false : null"
                      description="Mínimo 6 caracteres"
                    >
                      <b-form-input
                        id="new_password"
                        v-model="passwordForm.new_password"
                        type="password"
                        required
                        placeholder="Digite sua nova senha"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-6">
                    <b-form-group
                      label="Confirmar Nova Senha *"
                      label-for="confirm_password"
                      :invalid-feedback="errors.confirm_password"
                      :state="errors.confirm_password ? false : null"
                    >
                      <b-form-input
                        id="confirm_password"
                        v-model="passwordForm.confirm_password"
                        type="password"
                        required
                        placeholder="Confirme sua nova senha"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-secondary me-2"
                        @click="clearPasswordForm"
                        :disabled="submitting"
                      >
                        <i class="ri-refresh-line"></i>
                        Limpar
                      </button>
                      
                      <button
                        type="submit"
                        class="btn btn-primary ml-3"
                        :disabled="submitting || !isPasswordFormValid"
                      >
                        <i v-if="submitting" class="spinner-border spinner-border-sm me-2"></i>
                        <i v-else class="ri-lock-password-line"></i>
                        {{ submitting ? 'Alterando...' : 'Alterar Senha' }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authService } from "@/api/auth";

export default {
  name: "UserProfile",
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Meu Perfil",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Meu Perfil",
          active: true,
        },
      ],
      loading: false,
      submitting: false,
      userProfile: {},
      passwordForm: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      errors: {},
    };
  },
  computed: {
    isPasswordFormValid() {
      return (
        this.passwordForm.current_password &&
        this.passwordForm.new_password &&
        this.passwordForm.confirm_password &&
        this.passwordForm.new_password === this.passwordForm.confirm_password &&
        this.passwordForm.new_password.length >= 6
      );
    },
  },
  async created() {
    await this.loadUserProfile();
  },
  methods: {
    async loadUserProfile() {
      this.loading = true;
      try {
        // Primeiro tentar obter dados do localStorage
        const userData = localStorage.getItem('user');
        const userInfo = localStorage.getItem('userInfo');
        
        if (userInfo) {
          // Preferir userInfo se disponível (mais completo)
          this.userProfile = JSON.parse(userInfo);
        } else if (userData) {
          // Usar dados básicos do user se userInfo não estiver disponível
          const basicUserData = JSON.parse(userData);
          this.userProfile = basicUserData;
          
          // Tentar buscar dados completos da API
          try {
            const profile = await authService.getProfile();
            this.userProfile = profile.data || profile;
          } catch (apiError) {
            console.warn("Não foi possível buscar dados completos da API, usando dados do localStorage:", apiError);
          }
        } else {
          // Último recurso: buscar da API
          const profile = await authService.getProfile();
          this.userProfile = profile.data || profile;
        }
      } catch (error) {
        console.error("Erro ao carregar perfil:", error);
        this.$router.push("/");
      } finally {
        this.loading = false;
      }
    },

    async changePassword() {
      this.submitting = true;
      this.errors = {};

      // Validações locais
      if (this.passwordForm.new_password !== this.passwordForm.confirm_password) {
        this.errors.confirm_password = "As senhas não coincidem";
        this.submitting = false;
        return;
      }

      if (this.passwordForm.new_password.length < 6) {
        this.errors.new_password = "A senha deve ter pelo menos 6 caracteres";
        this.submitting = false;
        return;
      }

      try {
        await authService.changePassword({
          current_password: this.passwordForm.current_password,
          new_password: this.passwordForm.new_password,
        });
        
        this.$showSuccess("Senha alterada com sucesso!");
        this.clearPasswordForm();
        
      } catch (error) {
        console.error("Erro ao alterar senha:", error);
        
        // Tratar erros específicos
        if (error.response && error.response.status === 400) {
          this.errors.current_password = "Senha atual incorreta";
        } else if (error.response && error.response.data && error.response.data.detail) {
          const detail = error.response.data.detail;
          if (typeof detail === 'object') {
            this.errors = detail;
          } else {
            this.$showError(detail);
          }
        } else {
          this.$handleApiError(error);
        }
      } finally {
        this.submitting = false;
      }
    },

    clearPasswordForm() {
      this.passwordForm = {
        current_password: "",
        new_password: "",
        confirm_password: "",
      };
      this.errors = {};
    },

    getRoleLabel(role) {
      const roleLabels = {
        'ADMIN': 'Administrador',
        'DOCTOR': 'Médico',
        'TECHNICIAN': 'Técnico',
        'PATIENT': 'Paciente'
      };
      return roleLabels[role] || role;
    },
  },
};
</script>

<style scoped>
.form-control-plaintext {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  padding: 0.375rem 0.75rem;
}
</style>
